
export function formatarDocumento(text: string): string {
    if (text.length === 11) {
        return formatarCpf(text);
    } else if (text.length === 14) {
        return formatarCnpj(text);
    }
    return text;
}

export function formatarCnpj(text: string): string {
    return text.substring(0, 2) + "." + text.substring(2, 5) + "." + text.substring(5, 8) + "/" + text.substring(8, 12) + "-" + text.substring(12, 14);
}

export function formatarCpf(text: string): string {
    return text.substring(0, 3) + "." + text.substring(3, 6) + "." + text.substring(6, 9) + "-" + text.substring(9, 11);
}

export function localDateStringToDate(dateString: string): Date {
    const parts = dateString.split("-");
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
}

export function linhaDigitavelParaCodigoBarras(linha : string): string {
  const clean = linha.replace(/\D/g, "");

  if (clean.length !== 47) {
    throw new Error("Linha digitável inválida");
  }

  const bancoMoeda = clean.substring(0, 4);     // 0–3
  const campoLivre1 = clean.substring(4, 9);    // 4–8
  const campoLivre2 = clean.substring(10, 20);  // 10–19
  const campoLivre3 = clean.substring(21, 31);  // 21–30
  const dvGeral = clean.substring(32, 33);      // 32
  const fatorValor = clean.substring(33, 47);   // 33–46

  return (
    bancoMoeda +
    dvGeral +
    fatorValor +
    campoLivre1 +
    campoLivre2 +
    campoLivre3
  );
}